import { __assign, __rest } from "tslib";
import React, { Suspense, lazy, useContext, useMemo } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import retry from '../utils/webpack/chunkRetry';
import { LoadableComponentContext } from '../utils/hooks/useLoadableComponent';
/** Builds a lazy loaded editor component that calls a callback when loading finishes. */
var EditorLoaderFactory = function (cb) {
    return lazy(function () {
        return retry(function () {
            return import(
            /* webpackChunkName: "editor", webpackPrefetch: true */
            '../DaEditorWrapper/DaEditorWrapper.container').then(function (result) {
                cb();
                return result;
            });
        });
    });
};
/**
 * A context dependent version of our LoadableDaEditorWrapper.
 *
 * Usage:
 * ```jsx
 * // ButtonThatTriggersLoad would use `useContext(LoadableComponentContext)` under the hood.
 * <LoadableComponentContextProvider>
 *    <ButtonThatTriggersLoad />
 *    <LoadableDaEditorWrapper {...} />
 * </LoadableComponentContextProvider>
 * ```
 */
export var LoadableDaEditorWrapper = function (_a) {
    var LoadingComponent = _a.loadingComponent, rest = __rest(_a, ["loadingComponent"]);
    var _b = useContext(LoadableComponentContext), isLoadingTriggered = _b.isLoadingTriggered, finishLoading = _b.finishLoading;
    var Editor = useMemo(function () { return EditorLoaderFactory(finishLoading); }, [finishLoading]);
    if (!isLoadingTriggered) {
        return null;
    }
    return (React.createElement(ErrorBoundary, { debugComponent: "LoadableDaEditorWrapper" },
        React.createElement(Suspense, { fallback: React.createElement(LoadingComponent, null) },
            React.createElement(Editor, __assign({}, rest)))));
};
LoadableDaEditorWrapper.displayName = 'LoadableDaEditorWrapper';
export default LoadableDaEditorWrapper;
//# sourceMappingURL=LoadableDaEditorWrapper.js.map